<template>
  <svg viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 0.5H0V15.5C0 18.815 2.685 21.5 6 21.5H15C18.315 21.5 21 18.815 21 15.5V11H24C25.665 11 27 9.65 27 8V3.5C27 1.835 25.665 0.5 24 0.5ZM24 8H21V3.5H24V8ZM0 24.5H24V27.5H0V24.5Z"
      fill="currentColor"
    />
  </svg>
</template>
